import React, { Component, PropTypes } from "react"
import { Field, reduxForm } from "redux-form"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { createAccount, UpdateGEOAddress } from "../actions"
import { Col, Panel, Row, Alert } from 'react-bootstrap'
import Geosuggest from 'react-geosuggest';
import _ from 'lodash'
import axios from 'axios'
import RendererWithGoogleMap from './google_map'
//import GoogleMap from 'google-map-react';
import NavHeader from './navheader'
import SubMenu from './submenu'
import Demo from './getgeolocation'
import Footer from './footer'
import ComponentAddress from './component_address'
import { error } from "util";
import MetaTags from 'react-meta-tags'
import Stepper from 'react-stepper-horizontal';
var googleMapsClient = require('@google/maps').createClient({
    key: 'AIzaSyBUgGvMk0o9dlyKmGg-jIP_mrVnWMWQf3c'
});

const normalizePhone = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (!previousValue || value.length > previousValue.length) {
        // typing forward
        if (onlyNums.length === 3) {
            return onlyNums + '-'
        }
        if (onlyNums.length === 6) {
            return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-'
        }
    }
    if (onlyNums.length <= 3) {
        return onlyNums
    }
    if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3)
    }
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 6) + '-' + onlyNums.slice(6, 10)
}
class PageRegister extends Component {
    state = {
        showPassword: false,
        step: 1,
        showgeoaddress: "",
        lat: 0,
        lng: 0,
        deflat: 13.896995,
        deflng: 100.6064463,
        allowgetlocation: true,
        loading: false,
        postal_code: "",
        ismapinaccuracy: false,
        province: '',
        amphoe: '',
        district: '',
        zipcode: ''
    }
    renderField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.placeholder}</label>
                <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }
    renderFieldwithAddons(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.placeholder}</label>
                <div className="input-group">
                    <div className="input-group-addon">{field.addons}</div>
                    <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                </div>
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }
    componentDidMount() {
        window.fbq('trackCustom', 'Step1View')
        window.scrollTo(0, 0)
    }
    setRegisterPageState(values) {
        this.setState({ ...values })
    }
    onSubmit(values) {
        if (this.state.step != 2) {
            if (this.state.step == 3) {
                if (this.state.zipcode == '') {
                    window.alert('กรุณากรอกรหัสไปรษณีย์')
                } else {
                    this.setState({ step: this.state.step + 1 })
                    window.fbq('trackCustom', 'Step4View')
                }
            } else {
                if (this.state.step == 1) {
                    window.fbq('trackCustom', 'Step2View')
                } else if (this.state.step == 2) {
                    window.fbq('trackCustom', 'Step3View')
                }
                this.setState({ step: this.state.step + 1 })
            }
        } else {
            values['phone_number'] = values['phone_number'].replace(/\D+/g, '')
            delete values['confirm_password']
            // console.log(values)
            this.setState({ loading: true })
            this.props.createAccount(values, this.createAccountCallback.bind(this), this.createAccountCallbackErr.bind(this))
            // }
        }
    }
    createAccountCallback() {
        this.props.history.push('/register_successful')
    }
    createAccountCallbackErr(err) {
        window.alert(err)
        this.setState({ step: 1, loading: false })
    }
    handleChange(e) {
        this.setState({ showPassword: !this.state.showPassword })
    }
    renderStepOne() {
        const { handleSubmit } = this.props
        // this.props.invalid && this.props.pristine ? console.log('metatags') : ''
        return (
            <div>
                {this.props.invalid && this.props.pristine
                    ? <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags> : ''
                }
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                    <Field
                        placeholder="เบอร์โทรศัพท์(มือถือ)"
                        name="phone_number"
                        type='text'
                        addons={<i className="fa fa-phone" aria-hidden="true"></i>}
                        component={this.renderFieldwithAddons}
                        normalize={normalizePhone}
                    />
                    <Field
                        placeholder="รหัสผ่าน"
                        name="password"
                        addons={<i className="fa fa-key" aria-hidden="true"></i>}
                        type={this.state.showPassword ? 'text' : 'password'}
                        component={this.renderFieldwithAddons}
                    />
                    <Field
                        placeholder="ยืนยันรหัสผ่าน"
                        name="confirm_password"
                        addons={<i className="fa fa-key" aria-hidden="true"></i>}
                        type={this.state.showPassword ? 'text' : 'password'}
                        component={this.renderFieldwithAddons}
                    />
                    <label className="checkbox-inline">
                        <input type="checkbox" name='checkbox' value="toggle" onChange={this.handleChange.bind(this)} />แสดงรหัสผ่าน
          </label>
                    <p style={{ color: 'red' }}>* การใช้ตัวอักษรเล็กหรือตัวใหญ่มีผลต่อรหัสผ่าน และเพื่อความปลอดภัย รหัสผ่านต้องมีทั้งตัวอักษร และตัวเลข รวมกันอย่างน้อย 8 ตัว</p>
                    <button type="submit" className="btn btn-success max-width" >ถัดไป</button>
                </form>
            </div>
        )
    }
    renderStepTwo() {
        const { handleSubmit } = this.props
        return (
            <div>
                <h4>ข้อมูลส่วนตัว</h4>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                    {/* <Field
                        placeholder="คำนำหน้าชื่อ"
                        name="name_title"
                        type='text'
                        component={this.renderField}
                    /> */}
                    <Field
                        placeholder="ชื่อ"
                        name="name"
                        type='text'
                        addons={<i className="fa fa-user fa" aria-hidden="true"></i>}
                        component={this.renderFieldwithAddons}
                    />
                    <Field
                        placeholder="นามสกุล"
                        name="lastname"
                        type='text'
                        addons={<i className="fa fa-user fa" aria-hidden="true"></i>}
                        component={this.renderFieldwithAddons}
                    />
                    <Field
                        placeholder="อีเมล"
                        name="email"
                        type='email'
                        addons={<i className="fa fa-envelope fa" aria-hidden="true"></i>}
                        component={this.renderFieldwithAddons}
                    />
                    {/* <button type="submit" className="btn btn-success max-width" >สมัครสมาชิก</button> */}
                    <p>หากท่านได้ทำการกดปุ่มสมัครสมาชิก ทางบริษัทฯ ถือว่าท่านได้ยอมรับ <a style={{ cursor: 'pointer' }} href={'/terms_of_service'} target="_blank">เงื่อนไขการให้บริการ</a> และ
                     <a style={{ cursor: 'pointer' }} href={'/privacy'} target="_blank">นโยบายความเป็นส่วนตัว</a></p>
                    {this.state.loading ? <div className='loader'></div> : <button type="submit" className="btn btn-success max-width" >สมัครสมาชิก</button>}
                </form>
            </div>
        )
    }
    onSuggestSelect(suggest) {
        this.setlocation(suggest.location.lat, suggest.location.lng)
        this.setdefaultlocation(suggest.location.lat, suggest.location.lng)
    }
    setcentermap(lat, lng) {
        //console.log("CENLAT",lat,"CENLNG",lng)
        //this.getlocationaddress(lat, lng)
        this.setState({
            deflat: lat,
            deflng: lng
        })
    }
    setlocation(lat, lng) {
        //console.log("LAT",lat,"LNG",lng)
        this.getlocationaddress(lat, lng)
        this.setState({
            lat: lat,
            lng: lng
        })
    }
    setdefaultlocation(deflat, deflng) {
        //console.log("DEFLAT",deflat,"DEFLNG",deflng)
        //this.getlocationaddress(deflat, deflng)
        //this.getdistance(deflat, deflng)
        this.setState({ allowgetlocation: false })
        this.setState({
            deflat: deflat,
            deflng: deflng
        })
    }
    getlocationaddress(deflat, deflng) {
        const googlemapAPIUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${deflat},${deflng}&sensor=true&language=th`
        var self = this;
        axios
            .get(googlemapAPIUrl)
            .then(function (result) {
                if (result != null) {
                    self.checkismapinaccuracy(self.state.postal_code, result.data.results[4].address_components[0].long_name)
                    //self.props.change('address', result.data.results[0].formatted_address);
                }
            })
            .catch(function (error) {
                console.log("ERROR", "ไม่สามารถดึงค่าที่อยู่ได้");
            })
    }
    checkismapinaccuracy(postal_code, gmappostal_code) {
        if (!(postal_code == gmappostal_code)) {
            this.setState({ ismapinaccuracy: true })
        } else {
            this.setState({ ismapinaccuracy: false })
        }
    }
    render() {
        return (
            <div>
                <div className="container main-bg">
                    <NavHeader history={this.props.history} />
                    <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                    <Col md={3} sm={12} xs={12}>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <h3>ลงทะเบียน</h3>
                        <div>
                            <Stepper
                                activeColor='#F37232'
                                completeColor='#F37232'
                                circleFontSize={14}
                                circleTop={15}
                                size={30}
                                steps={[{ title: 'ขั้นตอนที่ 1' },
                                { title: 'ขั้นตอนที่ 2' },
                                // { title: 'ขั้นตอนที่ 3' },
                                // { title: 'ขั้นตอนที่ 4' }
                            ]}
                                activeStep={this.state.step - 1} />
                        </div>
                        <div style={{ marginTop: 10 }}></div>
                        <Panel>
                            {/* <h3>ขั้นตอนที่ {this.state.step}</h3> */}
                            {this.state.step == 1
                                ? this.renderStepOne.call(this)
                                : this.state.step == 2
                                    ? this.renderStepTwo.call(this)
                                    : this.state.step == 3
                                        ? this.renderStepThree.call(this)
                                        : this.renderStepFour.call(this)}
                        </Panel>
                    </Col>
                    <Col md={3} sm={12} xs={12}>
                    </Col>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}
function validate(values) {
    const errors = {}
    if (!values.phone_number) {
        errors.phone_number = 'กรุณาใส่เบอร์โทรศัพท์'
    }
    if (values.phone_number) {
        if (values.phone_number.length != 12) {
            errors.phone_number = 'กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง'
        }
    }
    if (!values.password) {
        errors.password = 'กรุณาใส่รหัสผ่าน'
    }
    if (!values.confirm_password) {
        errors.confirm_password = 'กรุณายืนยันรหัสผ่าน'
    }
    if (values.confirm_password && values.password && values.password != values.confirm_password) {
        errors.confirm_password = 'รหัสผ่านไม่ตรงกัน'
    }
    if (!values.name) {
        errors.name = 'กรุณาใส่ชื่อ'
    }
    if (!values.lastname) {
        errors.lastname = 'กรุณาใส่นามสกุล'
    }
    if (!values.email) {
        errors.email = 'กรุณาใส่อีเมลล์'
    }
    if (!values.residential_type) {
        errors.residential_type = 'กรุณาใส่ประเภทที่อยู่อาศัย'
    }
    if (!values.house_number) {
        errors.house_number = 'กรุณาใส่เลขที่บ้าน'
    }
    if (!values.zip_code) {
        errors.zip_code = 'กรุณาใส่รหัสไปรษณีย์'
    }
    if (!values.province) {
        errors.province = 'กรุณาใส่จังหวัด'
    }
    if (!values.district) {
        errors.district = 'กรุณาใส่แขวง'
    }
    if (!values.area) {
        errors.area = 'กรุณาใส่เขต'
    }
    return errors;
}
export default reduxForm({
    validate,
    form: "RegisterForm"
})(connect(null, { createAccount, UpdateGEOAddress })(PageRegister))


// WEBPACK FOOTER //
// ./src/components/page_register.js